var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"mr-3",attrs:{"variant":"gray-secondary","size":"lg"},on:{"click":_vm.onCancel}},[_c('span',[_vm._v("Cancel")])])
}
var staticRenderFns = []

export { render, staticRenderFns }